import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { LinkRecipeWithCustomerRecipeInput } from './LinkRecipeWithCustomerRecipeInput';
import { LinkRecipeWithCustomerRecipeOutput } from './LinkRecipeWithCustomerRecipeOutput';

export class LinkRecipeWithCustomerRecipeService extends HttpServiceBase {

  handle = (input: LinkRecipeWithCustomerRecipeInput): Promise<Result<LinkRecipeWithCustomerRecipeOutput> | null> => {
    const promise = this.http.post<Result<LinkRecipeWithCustomerRecipeOutput>,
      LinkRecipeWithCustomerRecipeInput>(`${this.baseUrlSislogApi}/v2/recipe/link-with-customer-recipe`, input);
    return promise;
  }
}